import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FrontendUserInfo } from "node-library/dist/portal";
import { FrontendContentPage } from "node-library/dist/constants";
import { CustomIconButton } from "../../common-components/button";

import { useSnackbar } from "../../common-components/toast/showToastMessage";
import {
	HeaderLanguageIcon,
	HeaderNotificationIcon,
	HeaderQuestionIcon,
} from "../../common-components/sidebarSvgIcons";

import { useLocation } from "react-router-dom";

interface Props {
	user: FrontendUserInfo | undefined;
	contentPage: FrontendContentPage;
	isExpanded: boolean;
	unsavedChanges: boolean;
	isSidebarExtended: boolean;
	navigateToContentPage: (page: FrontendContentPage) => void;
	setUnsavedChangesModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function DesktopHeader(props: Props) {
	const { t: translation } = useTranslation();

	const { openSnackbar } = useSnackbar();

	const [isMobile, setIsMobile] = useState(false);
	const [pageName, setPageName] = useState<string>("Home");
	const [subPageName, setSubPageName] = useState<string>();

	const location = useLocation(); // Get current URL path
	const isExpanded = props.isExpanded; // Sidebar state
	// Detect screen width and update `isMobile` state
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 600); // 600px breakpoint for mobile
		};

		handleResize(); // Check initial screen size
		window.addEventListener("resize", handleResize); // Add resize event listener

		return () => window.removeEventListener("resize", handleResize); // Cleanup event listener
	}, []);

	const user = props.user;

	function gotoPage(page: FrontendContentPage) {
		if (props.contentPage === page) {
			return;
		}
		if (!props.unsavedChanges) {
			props.navigateToContentPage(page);
		} else {
			props.setProceedAction(() => () => {
				props.navigateToContentPage(page);
			});
			props.setUnsavedChangesModalOpen(true);
		}
	}

	function getLocation() {
		const pathParts = location.pathname.split("/").filter(Boolean); // Split into segments
		const capitalize = (s: string) => {
			return s
				.split("-") // Split by " / "
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" "); // Capitalize each word
		};
		const mainPage = pathParts[1] || "Home"; // First segment as main page
		const subPage = pathParts[2] || ""; // Second segment as subpage (if exists)

		setPageName(capitalize(mainPage));
		setSubPageName(capitalize(subPage));
	}

	useEffect(() => {
		getLocation();
	}, [props.contentPage]);

	const actionElements = [
		{
			sectionLabel: "actionButton",
			children: [
				{
					label: "language",
					icon: <HeaderLanguageIcon></HeaderLanguageIcon>,
					onClick: () => {},
					// minimumRole: UserType.CLIENT,
				},
				{
					label: "notification",
					icon: <HeaderNotificationIcon></HeaderNotificationIcon>,

					onClick: () => {},
					// minimumRole: UserType.ENGINEER,
				},
				{
					label: "question",
					icon: <HeaderQuestionIcon></HeaderQuestionIcon>,

					onClick: () => {},
					// minimumRole: UserType.ADMIN,
				},
			],
		},
	];

	return (
		<div
			className={`landing-page-header${
				isExpanded
					? ``
					: ` header-container-sidebar-collapsed content-container-sidebar-collapsed`
			}`}
		>
			{/* <div
				className={`ppb-logo header-ppb-logo`}
				style={{
					paddingRight: props.isSidebarExtended ? "240px" : "0px",
					alignContent: "center",
					transition: "padding 0.3s ease",
				}}
			></div> */}
			<div className={`header-container`}>
				<div style={{ display: "flex" }}>
					<div
						className={`typography-body-01 ${
							subPageName && subPageName?.length > 0 ? "" : "typography-bold"
						}`}
					>
						{pageName} {subPageName ? ` / ${subPageName}` : ""}
					</div>
					{subPageName && subPageName?.length > 0 && (
						<div className={"typography-body-01 typography-bold"}>
							{` / ${subPageName}`}
						</div>
					)}
				</div>
				{actionElements.map((element, index) => {
					const rowItems: Array<React.ReactNode> = element.children.map(
						(childRow, index) => {
							if (user) {
								return (
									<CustomIconButton
										key={childRow.label}
										onClick={childRow.onClick}
										icon={childRow.icon}
										size="medium"
										id={`${childRow.label}-button`}
									></CustomIconButton>
								);
							} else {
								return null;
							}
						}
					);
					return isMobile ? null : (
						<div key={`desktop-header-action-${element.sectionLabel}`}>
							{rowItems}
						</div>
					);
				})}
			</div>
		</div>
	);
}
